var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4684 4.78947C12.3938 4.97001 13.2442 5.42256 13.9108 6.08921C14.5775 6.75584 15.0301 7.60625 15.2105 8.53158M11.4684 1C13.3909 1.21357 15.1836 2.07448 16.5523 3.44138C17.9209 4.80827 18.7841 6.5999 19 8.5221M15.6842 19C7.57435 19 1 12.4256 1 4.31579C1 3.9499 1.01339 3.58713 1.03969 3.22795C1.06987 2.81575 1.08496 2.60965 1.19298 2.42203C1.28245 2.26664 1.441 2.11928 1.60251 2.04139C1.7975 1.94737 2.02494 1.94737 2.4798 1.94737H5.14883C5.53134 1.94737 5.72259 1.94737 5.88655 2.01032C6.03137 2.06593 6.16033 2.15625 6.26208 2.27336C6.37727 2.40592 6.44263 2.58567 6.57336 2.94515L7.67809 5.98321C7.83015 6.40145 7.90622 6.61057 7.89334 6.80898C7.88197 6.98393 7.82219 7.15229 7.72082 7.29532C7.60587 7.45753 7.41506 7.57202 7.03344 7.80099L5.73684 8.57895C6.87548 11.0884 8.91062 13.1262 11.4211 14.2632L12.199 12.9666C12.428 12.5849 12.5425 12.3941 12.7046 12.2792C12.8477 12.1778 13.016 12.118 13.191 12.1067C13.3894 12.0938 13.5986 12.1699 14.0168 12.3219L17.0549 13.4266C17.4143 13.5574 17.5941 13.6227 17.7266 13.7379C17.8437 13.8397 17.9341 13.9686 17.9896 14.1135C18.0526 14.2774 18.0526 14.4686 18.0526 14.8512V17.5202C18.0526 17.975 18.0526 18.2025 17.9586 18.3975C17.8807 18.559 17.7334 18.7176 17.578 18.807C17.3903 18.915 17.1843 18.9301 16.7721 18.9603C16.4128 18.9866 16.0501 19 15.6842 19Z",
    stroke: "#464141",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.dd63b80a95c3ffd46b5ceab91fed0a90.svg";
export { ForwardRef as ReactComponent };